export class MsrnProviderBillingId {
	provider: string;
	billingId: string;

	//for GUI use
	selected: string;
}